import { store } from '../../index';
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import {
  useActiveStoreCatalog,
  useActiveStoreId,
  useIsStoreLoaded,
  useDietaryOptions,
  useFilteredItems,
} from "../../store/selectors/menu";
import { set_selected_store } from "../../store/actions/menuAction";
import {
  Grid,
  makeStyles,
  Typography,
  Button,
  IconButton,
  Paper,
  Card,
  Divider,
} from "@material-ui/core";
import cart from "../../assets/images/basket.svg";
import RecentOrderIcon from "../../assets/images/RecentOrder.svg";
import icon from "../../assets/img/Icon.png";
import { useNavigate, useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import InputBase from "@mui/material/InputBase";
import Items from "./Items";
import ChevronLeftTwoToneIcon from "@mui/icons-material/ChevronLeftTwoTone";
import { BUTTON_COLOR, TEXT_COLOR, TOKEN_KEY, IMG_URL } from "../../utils/constant";
import MenuIcon from "@mui/icons-material/Menu";
import Navbar from "../../components/Navbar";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { clearCart, removeItem } from "../../store/actions/cartActions";
import { check_inventory_stock, update_local_storage_stock, remove_out_of_stock_from_cart } from "../../utils/item_helper";
import { get_customer_list } from "../../utils/customer_helper";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  set_customer,
  set_last_order,
  set_order_type,
  set_filters,
  order_place,
  clear_last_order,
  clear_customer,
  clear_order_details,
  clear_order_type,
  clear_order_request,
  preload_menu_data,
} from "../../store/actions/action";

import SignInPopup from "../login/SignInPopup";
import MenuCategories from "./MenuCategories";
import FilterPopup from "./FilterPopup";
import defaultimg from "../../assets/images/default.png";
import CyntraLogo from "../../assets/images/cyntra_logo.svg";
import fssaiimage from "../../assets/images/fssai-logo-df4c.png";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import MuiMenu from "@mui/material/Menu";
import { hexToCSSFilter } from "hex-to-css-filter";
import deliveryIcon from "../../assets/images/DEL.svg";
import takeAway from "../../assets/images/TA.svg";
import dineIn from "../../assets/images/DI.svg";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { get_order_type } from "../../utils/order_helper";
import img1 from "../../assets/img/Icon.svg";
import { getFSRFlow, getFSRTableId, getFSRTableDisplayName, stripTablePrefix, getFSRTableCacheKey } from "../../utils/fsr_helper";

// Icons imports
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/ChevronLeft";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import GridViewIcon from "@mui/icons-material/GridView";
import ArticleIcon from "@mui/icons-material/Article";
import LogoutIcon from "@mui/icons-material/Logout";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import EditIcon from "@mui/icons-material/Edit";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CircularProgress from "@mui/material/CircularProgress";
import MenuPopup from "./MenuPopup";
import { VeganIcon } from "lucide-react";
import VegIcon from "../../assets/images/Veg Icon 1.svg";
import NonVegIcon from "../../assets/images/Non Veg Icon 1.svg";
import { fontFamily, fontWeight } from "@mui/system";
import TentPopup from "../../components/TentPopup";
import OrderTypePopup from "../../components/OrderTypePopup";
import useMediaQuery from '@mui/material/useMediaQuery';
import useIsDesktop from "../../hooks/useIsDesktop";

const useStyles = makeStyles({
  searchInput: {
    background: "#eeeeee",
    borderRadius: "0.5rem",
    width: "95%",
    margin: "5px auto",
    display: "flex",
  },
  sidebarHeader: {
    backgroundColor: "#f8f3e9",
    padding: "1rem",
  },
  profileSection: {
    backgroundColor: "#701005",
    color: "white",
    padding: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  profileIcon: {
    backgroundColor: "#ff8000",
    borderRadius: "50%",
    padding: "8px",
    marginRight: "12px",
    color: "white",
  },
  profileName: {
    fontWeight: "bold",
    fontSize: "1.2rem",
    marginBottom: "-5px",
  },
  profilePhone: {
    fontSize: "0.9rem",
  },
  menuItem: {
    padding: "1rem",
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #f2f2f2",
  },
  menuIcon: {
    marginRight: "1rem",
    color: "#712b00",
  },
  menuText: {
    color: "#5a2c09",
    fontWeight: "500",
  },
  crownsSection: {
    display: "flex",
    backgroundColor: "#3b1c0e",
    borderRadius: "8px",
    margin: "10px 15px",
    padding: "10px",
    justifyContent: "space-between",
  },
  crownButton: {
    backgroundColor: "#462719",
    color: "white",
    borderRadius: "20px",
    padding: "5px 15px",
    display: "flex",
    alignItems: "center",
  },
  redeemButton: {
    backgroundColor: "#e01e1a",
    color: "white",
    borderRadius: "20px",
    padding: "5px 15px",
  },
});
const buttonStyle = {
  margin: "0 4px",
  borderRadius: "8px",
  border: "1px solid #e0e0e0",
  background: "#fff",
  padding: "6px 12px",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "14px",
  fontWeight: 500,
  color: "#1a1a1a",
  boxShadow: "none",
  cursor: "pointer",
};
const buttonBaseStyle = {
  fontWeight: "600",
  fontFamily: "Satoshi",
  display: "flex",
  alignItems: "center",
  gap: "2px",
  border: "1px solid #e0e0e0",
  borderRadius: "8px",
  padding: "4px 7px",
  marginRight: "8px",
  backgroundColor: "white",
  fontSize: "14px",
  fontWeight: 500,
  color: "#1f2937",
  cursor: "pointer",
  height: "30px", // consistent height
};
const Menu = function (props) {
  // Hooks-based reads from the new catalogReducer + filterReducer. These run
  // alongside the legacy props injected by connect — we'll lean on them more
  // as children migrate off prop-spread.
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const sessionReducer = useSelector(state => state.sessionReducer) || {};
  const getFSRStatus = () => sessionReducer.is_fsr === true;
  const isBelow337 = useMediaQuery('(max-width: 336px)');
  const activeStoreId = useActiveStoreId();
  const activeCatalog = useActiveStoreCatalog();
  const isActiveLoaded = useIsStoreLoaded(activeStoreId);
  const dietaryOptions = useDietaryOptions();
  const filteredItems = useFilteredItems();
  const businessDate = sessionReducer?.store_details?.business_date;
  let user = props.reducer?.user || {};
  let storeConfig = sessionReducer.store_config || props.sessionReducer?.store_config || {};
  const location_id = sessionReducer.location_id || user.location_id;
  const isTentEnabled = storeConfig?.web_ordering_setting?.dining_preference_qr === "Tent No.";
  let tent_no = sessionReducer.tent_id ? `${sessionReducer.tent_id}` : (isTentEnabled ? (getFSRFlow()?.table_no || "") : "");
  let fsr_table_no = getFSRStatus() ? getFSRTableDisplayName() : "";
  const [selectedCategory, setSelectedCategory] = useState("All_Item");
  const [selectedCategoryName, setSelectedCategoryName] = useState("All Items");
  const sidebarCategoryRefs = useRef({});
  const sidebarContainerRef = useRef(null);
  const itemsContainerRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [dietaryArray, setDietaryArray] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [allCategoryList, setAllCategoryList] = useState([]);
  const [tagCategories, setTagCategories] = useState([]);
  const [allitem, setAllitem] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [addonList, setAddonList] = useState([]);
  const [labelList, setLabelList] = useState([]);
  const [selectedStore, setSelectedStore] = useState();
  const [orderType, SetorderType] = useState([]);
  const [guest, setGuest] = useState(false);
  const [goToCart, setGoToCart] = useState(false);
  const [selectedfilter, setSelectedfilter] = useState("");
  const [dietaryFilter, setDietaryFilter] = useState([]);

  const [itemVerriantList, setItemVerriantList] = useState([]);
  const [isReload, setIsReload] = useState(true);
  const [open, setOpen] = useState(false);
  const [anchorElSort, setAnchorElSort] = useState(null);
  const [openUserInfo, setOpenUserInfo] = useState(false);
  const [openTent, setOpenTent] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [originalItemList, setOriginalItemList] = useState([]);
  const [userIcon, setUserIcon] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [pendingStore, setPendingStore] = useState(null);
  const [openOutOfStock, setOpenOutOfStock] = useState(false);
  const [outOfStockItems, setOutOfStockItems] = useState([]);
  const isFSR = getFSRStatus();
  const { cartProps, reducer } = props;
  const appliedfilters = props.filterReducer;
  const { addedItems } = cartProps;
  const { customer } = reducer;
  const storeInfo = useSelector((s) => s.sessionReducer?.store_details);
  const storeInfoConfig = useSelector((s) => s.sessionReducer?.store_config);
  const storeFssai =
    storeInfo?.store_fssai ||
    storeInfo?.store?.store_fssai ||
    storeInfo?.store_fssai_lic_no ||
    storeInfo?.fssai_lic_no;
  const associated_stores = useSelector((s) => s.sessionReducer?.associated_stores);

  const storeCurrency = storeInfo?.store_currency;

  const [currency, setCurrency] = useState(() => {
    const currencyMap = {
      INR: "₹",
      USD: "$",
      CAD: "$",
      OMR: "OMR ",
      AED: "AED ",
    };

    return currencyMap[storeCurrency] || "$"; // Default to dollar if no match
  });

  let menuStore = storeInfoConfig?.web_ordering_setting?.is_menu;

  let tentno = storeInfoConfig?.web_ordering_setting?.dining_preference_qr == "Tent No.";

  let skipSigninCustomer =
    storeInfoConfig?.web_ordering_setting?.is_customer_screen_qr;

  let item_contain_tax =
    storeInfoConfig?.general_config?.item_price_contains_tax == "Include" ||
    false;

  let primaryColor = storeInfoConfig?.general_config?.primary_color || storeInfo?.primary_color || BUTTON_COLOR;
  let secondaryColor = storeInfoConfig?.general_config?.secondary_color;

  const classes = useStyles();
  const navigate = useNavigate();
  const { items: catalogItems } = useActiveStoreCatalog();

  const location = useLocation();


  // Direct table_id comparison — table_details comes from the API and is stored as-is in Redux.
  const isCurrentFSRTableOrder = (order) => {
    const sessionTableId = getFSRFlow()?.table_id;
    const orderTableId = order?.store_details?.table_id || order?.table_id;
    if (sessionTableId && orderTableId) return String(sessionTableId) === String(orderTableId);
    // Fallback: compare table_no if table_id is missing
    const sessionTableNo = stripTablePrefix(getFSRFlow()?.table_no || "");
    const orderTableNo = stripTablePrefix(order?.store_details?.table_no || order?.table_no || "");
    return sessionTableNo && sessionTableNo === orderTableNo;
  };

  const isFSROrderFromToday = (order) => {
    const rawDate = order?.business_date || order?.date_time || order?.created_at || "";
    const dateStr = String(rawDate).replace(" ", "T");
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return false;
    if (businessDate) {
      return dateStr.slice(0, 10) === businessDate.slice(0, 10);
    }
    const today = new Date();
    return (
      d.getDate() === today.getDate() &&
      d.getMonth() === today.getMonth() &&
      d.getFullYear() === today.getFullYear()
    );
  };

  const refreshFSRRunningOrder = async () => {
    const isLoggedIn = customer?.cust_mobile && customer?.guest !== "Guest";
    if (!isLoggedIn) return;

    try {
      const tableNo = getFSRTableCacheKey();
      const resp = await get_customer_list({
        cust_mobile: customer?.cust_mobile,
      });

      if (!resp?.order_details) return;

      const isOpenOrder = (order) => {
        const status = (order?.order_status || "").toUpperCase();
        const state = (order?.order_state || "").toUpperCase();
        const isClosed =
          status === "CLOSE" ||
          status === "CLOSED" ||
          status === "COMPLETED" ||
          status === "COMPLETE" ||
          status === "CANCELLED" ||
          state === "CLOSE" ||
          state === "CLOSED" ||
          state === "CANCELLED";
        return status === "OPEN" && !isClosed;
      };

      const openOrder = tableNo
        ? resp.order_details.find(
          (order) =>
            isCurrentFSRTableOrder(order) &&
            isOpenOrder(order) &&
            isFSROrderFromToday(order)
        )
        : null;

      if (openOrder) {
        props.set_last_order(resp);
        const foundTableId = openOrder?.store_details?.table_no || openOrder?.table_no || "";
        const cacheKey = tableNo || foundTableId;
        store.dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: cacheKey, data: { order: openOrder } } });
        store.dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: cacheKey, data: { items: openOrder.item_details } } });
        store.dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: cacheKey, data: { payBillEnabled: true } } });
        store.dispatch({ type: 'SET_OFFLINE_INVOICE_NO', offline_invoice_no: openOrder?.offline_invoice_no || null });
      } else {
        store.dispatch({ type: 'CLEAR_ACTIVE_TABLE_ORDER', payload: { tableNo } });
        store.dispatch({ type: 'SET_OFFLINE_INVOICE_NO', offline_invoice_no: null });
      }
    } catch (err) {
      console.error("[Menu] Error refreshing FSR running order:", err);
    }
  };

  const handleCheckout = async () => {
    try {
      const response = await check_inventory_stock({ items: addedItems });
      if (response && response.status === false) {
        update_local_storage_stock(response.out_of_stock_items || [], catalogItems, props.update_item_list);
        setOutOfStockItems(response.out_of_stock_items || []);
        setOpenOutOfStock(true);
        return;
      }
    } catch (e) {
      console.error("Error checking inventory stock:", e);
    }

    const isTableMgmt = getFSRStatus();
    const isLoggedIn = customer?.cust_mobile && customer?.guest !== "Guest";

    if (isTableMgmt) {
      const isCustomerScreenQR = storeInfoConfig?.web_ordering_setting?.is_customer_screen_qr;
      const skipCustomerScreen = isCustomerScreenQR === false || isCustomerScreenQR === "false" || isCustomerScreenQR === "No";

      if (!isLoggedIn && !skipCustomerScreen) {
        setOpenUserInfo(true);
        setGuest(false);
        setGoToCart(true);
        return;
      }
      await refreshFSRRunningOrder();
      navigate("/cart");
      return;
    }

    if (customer?.cust_first_name || customer?.guest) {
      navigate("/cart");
    } else if (addedItems.length) {
      if (!skipSigninCustomer) {
        navigate("/cart");
      } else {
        setOpenUserInfo(true);
      }
    } else {
      setOpenUserInfo(false);
    }
    setGuest(true);
    setGoToCart(true);
  };
  // Store original item list on first render
  useEffect(() => {
    if (originalItemList.length === 0 && itemList.length > 0) {
      setOriginalItemList([...itemList]);
    }
  }, [itemList, originalItemList.length]);

  // Check if any items have dietary information

  // const hasVeg = originalItemList.some((item) => item?.dietary?.toLowerCase()?.trim() === "veg");
  // const hasNonVeg = originalItemList.some((item) => {
  //   const d = item?.dietary?.toLowerCase()?.trim();
  //   return d === "non-veg" || d === "nonveg" || d === "non veg" || d === "non_veg" || d === "egg" || d === "eggetarian" || d === "eggiterian" || d === "eggitarian";
  // });

  const hasDietaryItems = true; // Always show dietary filters

  // const hasDietaryItems = originalItemList.some(
  //   (item) =>
  //     item.dietary && (item.dietary === "veg" || item.dietary === "non-veg")
  // );

  // Handle checkbox state changes
  const handleCheckboxChange = (item) => {
    setCheckedItems((prev) => {
      const next = prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item];
      setDietaryFilter(next.map(i => i.toLowerCase())); // Sync with dietaryFilter used by filterItems
      return next;
    });
  };

  // // Apply filters whenever checked items change
  // useEffect(() => {
  //   let filteredItems = [...originalItemList];

  //   // Apply dietary filter if any dietary items are checked
  //   if (checkedItems.length > 0) {
  //     filteredItems = filteredItems.filter((item) => {
  //       if (!item.dietary) return false;

  //       // Map the checkbox labels to actual dietary values
  //       const dietaryFilters = checkedItems.map((filter) => {
  //         if (filter === "Veg") return "veg";
  //         if (filter === "Non-veg") return "non-veg";
  //         return filter.toLowerCase();
  //       });

  //       return dietaryFilters.includes(item.dietary.toLowerCase());
  //     });
  //   }

  //   setItemList(filteredItems);
  // }, [checkedItems, originalItemList, setItemList]);

  const nonVegButtonStyle = {
    ...buttonStyle,
    backgroundColor: checkedItems.includes("Non-veg") ? "#f0f0f0" : "white",
  };

  useEffect(() => {
    const fetchOrderType = async () => {
      const { token, store_id } = sessionReducer;
      if (!token || !store_id) return;
      const storeOrderType = await get_order_type({ token, store_id });
      SetorderType(storeOrderType);
    };
    fetchOrderType();
  }, [sessionReducer.token, sessionReducer.store_id]);

  useEffect(() => {
    const isActive = (obj) => obj && obj.status !== false && obj.status !== "false";
    const catData = (activeCatalog?.categories || []).filter(isActive);
    const inactiveCatIds = new Set(
      (activeCatalog?.categories || [])
        .filter((cat) => !isActive(cat))
        .map((cat) => String(cat?.category_id || cat?._id))
    );
    const isItemActive = (item) => {
      if (!isActive(item)) return false;
      if (item.category_id && inactiveCatIds.has(String(item.category_id))) return false;
      return true;
    };
    const itemData = (activeCatalog?.items || []).filter(isItemActive);
    const addons = (activeCatalog?.addons || []).filter(isActive);
    const label = (activeCatalog?.labels || []).filter(isActive);
    const allItemVerriant = (activeCatalog?.item_variants || []).filter(isActive);

    setCategoryList(catData);
    setAllCategoryList(catData);
    setAllitem(itemData);
    setItemVerriantList(allItemVerriant);
    setAddonList(addons);
    setLabelList(label);

    setIsReload(!itemData.length);

    const uniqueDietarySet = new Set();
    itemData.forEach((item) => {
      if (item?.dietary) uniqueDietarySet.add(item.dietary.toLowerCase());
    });
    setDietaryArray(Array.from(uniqueDietarySet));
  }, [activeCatalog]);

  // Derive tagCategories whenever allitem changes
  useEffect(() => {
    if (!allitem?.length) return;
    const tagSet = new Set();
    allitem.forEach((item) => {
      if (Array.isArray(item?.tag)) {
        item.tag.forEach((t) => { if (t && t.trim()) tagSet.add(t.trim()); });
      }
    });
    const builtTagCats = Array.from(tagSet).map((tag) => ({
      category_id: `tag__${tag}`,
      category_name: tag,
      isTag: true,
    }));
    setTagCategories(builtTagCats);
  }, [allitem]);

  useEffect(() => {
    let _filteredData = allitem;
    if (searchQuery && searchQuery.trim()) {
      const tokens = searchQuery.trim().split(/\s+/).filter(Boolean);
      const tokenRegexes = tokens.map((tok) => {
        const base = tok.replace(/(?:s|es)$/i, "");
        const escBase = base.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const escTok = tok.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        return new RegExp(`\\b(?:${escTok}|${escBase}(?:s|es)?)`, "i");
      });

      _filteredData = _filteredData.filter((data) => {
        const catObj =
          (allCategoryList || []).find((c) => String(c.category_id) === String(data.category_id)) ||
          (categoryList || []).find((c) => String(c.category_id) === String(data.category_id));
        const catName = data.category_name || catObj?.category_name || "";

        const itemTags = Array.isArray(data.tag)
          ? data.tag
          : (Array.isArray(data.tags) ? data.tags : (data.tags ? String(data.tags).split(",") : []));

        const itemSearchable = [
          data.item_name,
          data.item_description,
          data.description,
          catName,
          data.dietary,
          ...itemTags,
        ]
          .filter(Boolean)
          .join(" ");

        return tokenRegexes.every((rgx) => rgx.test(itemSearchable));
      });
    }
    setItemList(_filteredData);
  }, [searchQuery, allitem, allCategoryList, categoryList]);

  useEffect(() => {
    const { obj, type } = appliedfilters?.category || {};
    filterItems(obj, type);
  }, [allitem, selectedfilter, dietaryFilter, appliedfilters?.selected_store, appliedfilters?.category]);

  //Prevent category fill

  useEffect(() => {
    if (!isDesktop && appliedfilters?.category) {
      props.set_filters({ ...appliedfilters, category: "" });
    }
  }, [isDesktop]);

  // Scroll to top when category changes in desktop view
  useEffect(() => {
    if (isDesktop && itemsContainerRef.current) {
      itemsContainerRef.current.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [selectedCategory, isDesktop]);

  useEffect(() => {
    if (!appliedfilters?.selected_store && location.state?.selectedStore) {
      props.set_filters({ ...appliedfilters, selected_store: location.state.selectedStore, category: "" });
    }

    setSelectedStore(
      appliedfilters?.selected_store
        ? appliedfilters?.selected_store?._id
        : location.state?.selectedStore
          ? location.state.selectedStore._id || location.state.selectedStore.id
          : associated_stores?.length > 1
            ? associated_stores[1]?._id
            : associated_stores[0]?._id || null
    );
  }, [appliedfilters, location.state]);

  useEffect(() => {
    if (location.state?.selectedCategory && (allCategoryList?.length > 0 || tagCategories?.length > 0)) {
      const catId = location.state.selectedCategory;
      const activeCat = allCategoryList.find(c => String(c.category_id) === String(catId));
      const activeTag = tagCategories.find(t => String(t.category_id) === String(catId) || String(t.category_name) === String(catId));
      if (activeCat) {
        setSelectedCategory(catId);
        setSelectedCategoryName(activeCat.category_name);

        // Ensure Redux filter state also reflects this so items are actually filtered
        const filterObj = { type: "category", obj: activeCat };
        props.set_filters({ ...appliedfilters, category: filterObj });

        // Clear the selectedCategory from state so it doesn't force this category on every re-render
        const newState = { ...location.state };
        delete newState.selectedCategory;
        navigate(location.pathname, { replace: true, state: newState });
      } else if (activeTag) {
        setSelectedCategory(activeTag.category_id);
        setSelectedCategoryName(activeTag.category_name);

        const filterObj = { type: "label", obj: activeTag };
        props.set_filters({ ...appliedfilters, category: filterObj });

        const newState = { ...location.state };
        delete newState.selectedCategory;
        navigate(location.pathname, { replace: true, state: newState });
      }
    }
  }, [location.state?.selectedCategory, allCategoryList, tagCategories]);

  useEffect(() => {
    if (selectedCategory) {
      const timer = setTimeout(() => {
        window.scrollTo(0, 0);
        if (selectedCategory === "All_Item") {
          if (sidebarContainerRef.current) {
            sidebarContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
          }
        } else {
          const container = sidebarContainerRef.current;
          const catElement = sidebarCategoryRefs.current[String(selectedCategory)];
          if (container && catElement) {
            const containerRect = container.getBoundingClientRect();
            const catRect = catElement.getBoundingClientRect();
            const relativeTop = catRect.top - containerRect.top + container.scrollTop;
            const targetTop = Math.max(0, relativeTop - (container.clientHeight / 2) + (catElement.clientHeight / 2));
            container.scrollTo({
              top: targetTop,
              behavior: "smooth",
            });
          }
        }
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [selectedCategory, allCategoryList, tagCategories]);

  useEffect(() => {
    const selectedStoreId = appliedfilters?.selected_store?.store_id;
    if (selectedStoreId) {
      setTimeout(() => {
        const element = document.getElementById(`store-tab-${selectedStoreId}`);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        }
      }, 150);
    }
  }, [appliedfilters?.selected_store?.store_id]);

  useEffect(() => {
    let store;
    const is_multi_store_qr = storeInfoConfig?.web_ordering_setting?.is_multi_store_qr;

    if (!is_multi_store_qr) {
      store = storeInfo?.store_id;
    } else if (associated_stores.length > 1) {
      store = appliedfilters?.selected_store?.store_id
        ? appliedfilters.selected_store.store_id
        : associated_stores[1]?.store_id;
    } else {
      store = associated_stores[0]?.store_id;
    }

    const filteredCategories =
      categoryList?.filter((e) => String(e?.store_id) == String(store)) || [];
    setAllCategoryList(filteredCategories);
  }, [categoryList, appliedfilters?.selected_store]);

  const handleStoreTabClick = (ele) => {
    const single_outlet = storeInfoConfig?.web_ordering_setting?.single_outlet_per_session;
    const currentCartStoreId = addedItems?.[0]?.store_id;

    if (single_outlet && currentCartStoreId && String(currentCartStoreId) !== String(ele?.store_id)) {
      setPendingStore(ele);
      setConfirmPopup(true);
    } else {
      onClickStore(ele);
      setSelectedStore(ele._id);
    }
  };

  const confirmStoreTabSwitch = () => {
    props.clearCart();
    setConfirmPopup(false);
    if (pendingStore) {
      onClickStore(pendingStore);
      setSelectedStore(pendingStore._id);
    }
  };

  const onClickStore = async (obj) => {
    setSelectedCategory("All_Item");
    setSelectedCategoryName("All Items");
    // Writes filterReducer.selected_store (drives useActiveStoreId) and mirrors to legacy appliedfilters.
    dispatch(set_selected_store(obj));
  };

  const filterItems = (obj, type) => {
    // Active-store catalog already store-scoped via useActiveStoreCatalog (catalogReducer.by_store[sid]).
    let filered = [...(activeCatalog.items || [])];
    console.log("DEBUG: filterItems - active store items count:", filered.length);

    let name = selectedCategoryName;
    let id = selectedCategory;
    if (obj || type) {
      if (obj?.category_id === "All_Item") {
        name = "All Items";
        id = "All_Item";
      } else if (type === "category") {
        filered = filered.filter((e) => String(e?.category_id) === String(obj.category_id));
        name = obj.category_name;
        id = obj.category_id;
      } else if (type === "label") {
        const targetTag = (obj?.name || obj?.category_name || (typeof obj === "string" ? obj : "")).trim();
        filered = filered.filter((e) => {
          if (!e?.tag) return false;
          if (Array.isArray(e.tag)) {
            return e.tag.some((t) => typeof t === "string" && t.trim().toLowerCase() === targetTag.toLowerCase());
          }
          if (typeof e.tag === "string") {
            return e.tag.trim().toLowerCase() === targetTag.toLowerCase();
          }
          return false;
        });
        name = targetTag;
        id = obj?.category_id || (targetTag ? `tag__${targetTag}` : "All_Item");
      }
      setSelectedCategory(id);
      setSelectedCategoryName(name);
    }

    if (dietaryFilter.length > 0) {
      filered = filered.filter((item) =>
        dietaryFilter.includes(item.dietary?.toLowerCase())
      );
    }

    if (selectedfilter === "low") {
      filered.sort((a, b) => {
        const priceA = a?.item_variant?.[0]?.plu || 0;
        const priceB = b?.item_variant?.[0]?.plu || 0;
        return parseFloat(priceA) - parseFloat(priceB);
      });
    } else if (selectedfilter === "high") {
      filered.sort((a, b) => {
        const priceA = a?.item_variant?.[0]?.plu || 0;
        const priceB = b?.item_variant?.[0]?.plu || 0;
        return parseFloat(priceB) - parseFloat(priceA);
      });
    }

    setItemList([...filered]);
  };
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [skipSignin, setSkipSignin] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const selectedStyle = (index) => {
    return {
      padding: "5px",
      minWidth: "80px",
      margin: "4px 4px",
      minHeight: "85px",
      display: "flex",
      alignContent: "center",
      flexWrap: "wrap",
      justifyContent: "center",
      borderRadius: "8px",
      boxShadow:
        selectedStore === index
          ? "0 4px 12px rgba(0,0,0,0.15), inset 0 0 0 2px #2196F3"
          : "0 2px 8px rgba(0,0,0,0.1)",
      background: selectedStore === index ? "#E3F2FD" : "white",
      position: "relative",
      color: selectedStore === index ? "#1976D2" : "#333",
      marginRight: "8px",
      transition: "all 0.3s ease",
      cursor: "pointer",
      border:
        selectedStore === index ? "2px solid #2196F3" : "2px solid transparent",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
      },
    };
  };

  const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  const ItemGroupByStore = groupBy(addedItems, "store_id");

  const getCount = function (store_id) {
    const filter = addedItems.filter((e) => e.store_id === store_id);
    const quantity = filter.length;
    return quantity;
  };

  let Type = orderType?.filter((data) => data?.status === true);
  if (sessionReducer?.is_fsr || getFSRStatus()) {
    Type = Type?.filter((data) => data?.order_code?.toLowerCase() === "di");
  }

  let type = props.cartProps?.orderType?.order;

  const [selectOrderType, setSelectOrderType] = useState(() => {
    if (getFSRStatus()) return "DI";
    if (location_id === "ta") return "TA";
    if (location_id) return "DI";
    return type?.order_code || "DI";
  });
  const [openOrderTypePopup, setOpenOrderTypePopup] = useState(false);
  const [pendingOrderType, setPendingOrderType] = useState(null);

  useEffect(() => {
    if (selectOrderType && orderType && orderType.length > 0) {
      const matchedOrder = orderType.find(
        (data) => data?.order_code === selectOrderType
      );
      if (matchedOrder && props.cartProps?.orderType?.order?.order_code !== selectOrderType) {
        props.set_order_type({ order: matchedOrder });
      }
    }
  }, [selectOrderType, orderType]);

  const handleChange = (event) => {
    const selectedCode = event.target.value;
    const matchedOrder = orderType?.find(
      (data) => data?.order_code === selectedCode
    );

    if (selectedCode === "DI" || selectedCode === "di") {
      setSelectOrderType(selectedCode);
      if (matchedOrder) {
        props.set_order_type({ order: matchedOrder });
      }
      if (!menuStore && tentno && !location_id && !sessionReducer?.is_fsr) {
        setOpenTent(true);
      }
      return;
    }

    localStorage.removeItem("TENT");
    dispatch({
      type: 'WEB_LOGIN',
      payload: {
        ...sessionReducer,
        ...(tentno && !location_id ? { table_details: {} } : {}),
        tent_id: null
      }
    });

    setSelectOrderType(selectedCode);
    if (matchedOrder) {
      props.set_order_type({ order: matchedOrder });
    }
  };

  // Updated sidebar menu items with modern styling

  useEffect(() => {
    let tentNo = sessionReducer.tent_id || sessionReducer.table_details?.table_no || "";

    if (!menuStore && !tentNo && selectOrderType == "DI" && tentno && !location_id) {
      setOpenTent(true);
    }
  }, [selectOrderType, location_id]);

  // FSR active-order cleanup — mirrors FSR-Orders.js loadFromLocalStorage logic.
  // When the user returns to the menu screen (e.g. after a payment on /order-status),
  // check the cached active table order and evict it if it has been closed/paid.
  useEffect(() => {
    const isFSR = getFSRStatus();
    if (!isFSR) return;

    try {
      const tableNo = getFSRTableCacheKey();
      if (!tableNo || tableNo === "default") return;

      const savedOrderStr = (store.getState().customerReducer.active_table_orders[tableNo]?.order ? JSON.stringify(store.getState().customerReducer.active_table_orders[tableNo].order) : null);
      if (!savedOrderStr) return;

      const savedOrder = JSON.parse(savedOrderStr);

      // Evict only when the cached order is definitely stale — from a previous business date.
      const rawDate = savedOrder?.business_date || savedOrder?.date_time || savedOrder?.created_at || "";
      const dateStr = rawDate.replace(" ", "T");
      const d = new Date(dateStr);
      let isToday = false;
      if (!isNaN(d.getTime())) {
        const orderDateOnly = dateStr.slice(0, 10);
        if (businessDate) {
          isToday = orderDateOnly === businessDate.slice(0, 10);
        }
        if (!isToday) {
          const today = new Date();
          isToday =
            d.getDate() === today.getDate() &&
            d.getMonth() === today.getMonth() &&
            d.getFullYear() === today.getFullYear();
        }
      }

      if (!isToday) {
        store.dispatch({ type: 'CLEAR_ACTIVE_TABLE_ORDER', payload: { tableNo: tableNo } });
        props.clear_last_order();
      }
    } catch (e) {
      console.error("[Menu] Error checking active FSR order:", e);
    }
  }, [location]);

  const getPaddingBottom = () => {
    return isDesktop ? "0px" : `calc(92px + env(safe-area-inset-bottom, 0px))`;
  };

  return (
    <>
      <div style={{ backgroundColor: "white", minHeight: "100vh", paddingBottom: getPaddingBottom() }}>
        <Navbar cart item selectOrderType={selectOrderType} />
        <SignInPopup
          {...props}
          {...{
            openUserInfo,
            userIcon,
            setOpenUserInfo,
            storeInfo,
            storeInfoConfig,
            guest,
            goToCart,
          }}
        />
        <TentPopup
          {...props}
          {...{
            openTent,
            storeInfoConfig,
            setOpenTent,
          }}
        />
        <OrderTypePopup
          open={openOrderTypePopup}
          onClose={() => {
            setOpenOrderTypePopup(false);
            setPendingOrderType(null);
          }}
          onConfirm={() => {
            if (pendingOrderType) {
              const event = { target: { value: pendingOrderType.order_code } };
              handleChange(event);
            }
            setOpenOrderTypePopup(false);
            setPendingOrderType(null);
          }}
          orderType={pendingOrderType}
          storeInfo={storeInfo}
          storeInfoConfig={storeInfoConfig}
        />
        <Grid container justifyContent="center" xs={12} sm={12} md={12} lg={12}>
          {/* Enhanced Header Section */}
          {isDesktop && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 20px",
                borderBottom: "1px solid #eaeaea",
                backgroundColor: "white",
                width: "100%",
                boxSizing: "border-box"
              }}
            >
              {/* Order Types */}
              <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <Typography style={{ fontWeight: 600, marginRight: "16px", color: '#333', fontSize: "18px" }}>Order Type</Typography>
                {Type?.map((e) => {
                  const isSelected = selectOrderType === e.order_code;

                  const safeHexColor = (color) => {
                    if (!color || typeof color !== 'string') return '#000000';
                    if (color.toLowerCase() === 'black') return '#000000';
                    if (color.toLowerCase() === 'white') return '#ffffff';
                    if (!color.startsWith('#')) return `#${color}`;
                    return color;
                  };
                  let activeFilter = "";
                  try {
                    activeFilter = hexToCSSFilter(safeHexColor(primaryColor || "#000000")).filter;
                  } catch (err) {
                    activeFilter = "";
                  }
                  let inactiveFilter = "";
                  try {
                    inactiveFilter = hexToCSSFilter("#333333").filter;
                  } catch (err) {
                    inactiveFilter = "";
                  }
                  const currentFilter = isSelected && activeFilter ? `brightness(0) ${activeFilter}` : (!isSelected && inactiveFilter ? `brightness(0) ${inactiveFilter}` : "none");
                  return (
                    <button
                      key={e._id}
                      onClick={() => {
                        if (isSelected) return;
                        setPendingOrderType(e);
                        setOpenOrderTypePopup(true);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "7px 16px",
                        borderRadius: "4px",
                        border: isSelected ? `1px solid ${primaryColor || BUTTON_COLOR}` : "1px solid #eaeaea",
                        backgroundColor: isSelected ? `${primaryColor || BUTTON_COLOR}15` : "white",
                        color: isSelected ? (primaryColor || BUTTON_COLOR) : "#333",
                        fontWeight: 500,
                        fontSize: "18px",
                        cursor: "pointer",
                        transition: "all 0.2s"
                      }}
                    >
                      {e.order_code?.toLowerCase() === 'di' ? (
                        <img src={dineIn} alt="" style={{ height: "18px", filter: currentFilter }} />
                      ) : e.order_code?.toLowerCase() === 'ta' ? (
                        <img src={takeAway} alt="" style={{ height: "18px", filter: currentFilter }} />
                      ) : e.order_code?.toLowerCase() === 'del' ? (
                        <img src={deliveryIcon} alt="" style={{ height: "18px", filter: currentFilter }} />
                      ) : null}
                      {e.order_type}
                      {e.order_code?.toLowerCase() === 'di' && (fsr_table_no || tent_no) ? ` (${fsr_table_no || tent_no})` : ""}
                    </button>
                  );
                })}
              </div>

              {/* Right side: Sort and Filters */}
              <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <button
                  onClick={(e) => setAnchorElSort(e.currentTarget)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    padding: "7px 10px 7px 16px",
                    height: "38px",
                    boxSizing: "border-box",
                    borderRadius: "4px",
                    border: "1px solid #eaeaea",
                    backgroundColor: "white",
                    color: "#333",
                    fontWeight: 500,
                    fontSize: "18px",
                    cursor: "pointer",
                    transition: "all 0.2s"
                  }}
                >
                  Sort By <KeyboardArrowDownIcon style={{ color: primaryColor || BUTTON_COLOR, fontSize: "22px" }} />
                </button>
                <MuiMenu
                  anchorEl={anchorElSort}
                  open={Boolean(anchorElSort)}
                  onClose={() => setAnchorElSort(null)}
                  PaperProps={{
                    style: { borderRadius: '8px', marginTop: '8px', minWidth: '160px', boxShadow: '0px 4px 12px rgba(0,0,0,0.1)' }
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setSelectedfilter("low");
                      setAnchorElSort(null);
                    }}
                    style={{
                      fontWeight: selectedfilter === "low" ? 600 : 500,
                      color: selectedfilter === "low" ? (primaryColor || BUTTON_COLOR) : "#333",
                      fontSize: "16px"
                    }}
                  >
                    Price - Low To High
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSelectedfilter("high");
                      setAnchorElSort(null);
                    }}
                    style={{
                      fontWeight: selectedfilter === "high" ? 600 : 500,
                      color: selectedfilter === "high" ? (primaryColor || BUTTON_COLOR) : "#333",
                      fontSize: "16px"
                    }}
                  >
                    Price - High To Low
                  </MenuItem>
                </MuiMenu>
                {hasDietaryItems && (
                  <>
                    <button
                      onClick={() => handleCheckboxChange("Non-veg")}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "7px 14px",
                        height: "38px",
                        boxSizing: "border-box",
                        borderRadius: "4px",
                        border: checkedItems.includes("Non-veg") ? "1px solid red" : "1px solid #eaeaea",
                        backgroundColor: checkedItems.includes("Non-veg") ? "#fff0f0" : "white",
                        color: "#333",
                        fontWeight: 500,
                        fontSize: "16px",
                        cursor: "pointer",
                        transition: "all 0.2s"
                      }}
                    >
                      <img src={NonVegIcon} alt="Non-Veg" style={{ height: "12px" }} /> Non-Veg
                    </button>
                    <button
                      onClick={() => handleCheckboxChange("Veg")}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "7px 14px",
                        height: "38px",
                        boxSizing: "border-box",
                        borderRadius: "4px",
                        border: checkedItems.includes("Veg") ? "1px solid green" : "1px solid #eaeaea",
                        backgroundColor: checkedItems.includes("Veg") ? "#f0fff0" : "white",
                        color: "#333",
                        fontWeight: 500,
                        fontSize: "16px",
                        cursor: "pointer",
                        transition: "all 0.2s"
                      }}
                    >
                      <img src={VegIcon} alt="Veg" style={{ height: "12px" }} /> Veg
                    </button>
                  </>
                )}
              </div>
            </div>
          )}
          {!isDesktop && (
            <div style={{ width: '100%' }}>
              <div
                style={{
                  margin: "0",
                  padding: isFSR ? "4px 16px" : "10px 16px",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "nowrap",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "white",
                  borderRadius: associated_stores?.length > 1 ? "0" : "0px",
                  position: "relative",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              >
                {/* Left element: Logo (if not multi-store-qr) OR Back button + Logo (if multi-store-qr) */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flex: "0 0 auto",
                    marginRight: "8px",
                  }}
                >
                  {associated_stores?.length > 1 && storeInfoConfig?.web_ordering_setting?.is_multi_store_qr ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <IconButton
                        style={{
                          color: "black",
                          backgroundColor: "rgba(255,255,255,0.2)",
                          borderRadius: "8px",
                          padding: "4px",
                          marginRight: "4px"
                        }}
                        onClick={() => {
                          associated_stores.length > 1
                            ? navigate("/stores")
                            : navigate("/", { state: { skipAutoRedirect: true } });
                        }}
                      >
                        <ChevronLeftTwoToneIcon style={{ fontSize: "20px" }} />
                      </IconButton>
                      <img
                        alt="Logo"
                        style={{
                          height: "18px",
                          maxWidth: "60px",
                          objectFit: "contain",
                        }}
                        src={storeInfo?.store_display_logo || " "}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "";
                        }}
                      />
                    </div>
                  ) : (
                    <img
                      alt="Logo"
                      style={{
                        maxWidth: storeInfo?.store_id === "1300" ? "48px" : "70px",
                        height: "auto",
                      }}
                      src={storeInfo?.store_display_logo || defaultimg}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = defaultimg;
                      }}
                    />
                  )}
                </div>

                {/* Center element: Order Type Dropdown / Menu title (only if not multi-store-qr, or if Table Management is enabled) */}
                {(!(associated_stores?.length > 1 && storeInfoConfig?.web_ordering_setting?.is_multi_store_qr) || getFSRStatus()) && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flex: 1,
                      minWidth: 0,
                    }}
                  >
                    <Box style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                      {storeInfoConfig?.web_ordering_setting?.is_menu ? (
                        <Typography
                          variant="h5"
                          style={{
                            fontWeight: "700",
                            color: "#2C3E50",
                            fontSize: "24px",
                          }}
                        >
                          Menu
                        </Typography>
                      ) : (
                        <FormControl
                          size="small"
                          variant="outlined"
                          style={{
                            backgroundColor: "#F8F9FA",
                            minWidth: "120px",
                            maxWidth: "100%"
                          }}
                        >
                          <Select
                            value={selectOrderType}
                            onChange={handleChange}
                            disabled={location_id}
                            // In FSR mode or when disabled (location_id) the order type is fixed — hide the dropdown arrow
                            IconComponent={(getFSRStatus() || location_id) ? () => null : undefined}
                            style={{
                              borderRadius: "8px",
                              fontWeight: "600",
                            }}
                            sx={{
                              // Remove the right padding that MUI reserves for the arrow icon and center text when fixed
                              ...((getFSRStatus() || location_id) && {
                                "& .MuiSelect-select": {
                                  paddingRight: "14px !important",
                                  textAlign: "center",
                                }
                              })
                            }}
                          >
                            {Type?.map((e) => (
                              <MenuItem key={e._id} value={e.order_code}>
                                {e.order_type?.toUpperCase()}{" "}
                                {getFSRStatus()
                                  ? ""
                                  : location_id === "ta"
                                    ? `(${e.order_code})`
                                    : (location_id && !sessionReducer.tent_id && isNaN(Number(location_id)))
                                      ? `(${location_id})`
                                      : ""}
                                {e.order_code === "DI" && (fsr_table_no || tent_no)
                                  ? ` (${fsr_table_no || tent_no})`
                                  : ""}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Box>
                  </div>
                )}

                {/* Right element: Hamburger Menu Button */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    flex: "0 0 auto",
                    marginLeft: "8px"
                  }}
                >
                  {!props.cart && (
                    <IconButton onClick={handleSidebarOpen} style={{ padding: "8px" }}>
                      <MenuIcon fontSize="large" style={{ color: primaryColor || BUTTON_COLOR }} />
                    </IconButton>
                  )}
                </div>
              </div>

              {/* Modern Store Selection Header and Search/Filter Container */}
              <div
                style={{
                  backgroundColor: "white",
                  borderBottomLeftRadius: "24px",
                  borderBottomRightRadius: "24px",
                  borderBottom: `4px solid ${primaryColor || BUTTON_COLOR}`,
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
                  paddingBottom: isFSR ? "8px" : "16px",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  boxSizing: "border-box",
                }}
              >
                {associated_stores?.length > 1 && storeInfoConfig?.web_ordering_setting?.is_multi_store_qr ? (
                  <div
                    style={{
                      width: "100%",
                      padding: "8px 0 0 0",
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "white",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        overflowX: "auto",
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        width: "100%",
                        padding: "8px 18px",
                        boxSizing: "border-box",
                        gap: "12px",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                      }}
                    >
                      {associated_stores
                        ?.filter(
                          (s) => String(s.store_id) !== String(storeInfo?.store_id)
                        )
                        ?.map((ele, index) => {
                          const isSelected = selectedStore === ele._id;
                          const cartCount = getCount(ele.store_id);
                          const formattedCount = cartCount > 9 ? String(cartCount) : `0${cartCount}`;

                          return (
                            <div
                              key={index}
                              id={`store-tab-${ele.store_id}`}
                              onClick={() => handleStoreTabClick(ele)}
                              style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: isSelected ? "96px" : "72px",
                                height: isSelected ? "96px" : "72px",
                                minWidth: isSelected ? "96px" : "72px",
                                minHeight: isSelected ? "96px" : "72px",
                                backgroundColor: "white",

                                border: isSelected
                                  ? `2px solid #EEEEEE`
                                  : "1.5px solid #EEEEEE",
                                borderRadius: "5px",

                                boxShadow: isSelected
                                  ? "0px 0px 26.4px 0px #0000001F"
                                  : "none",
                                cursor: "pointer",
                                boxSizing: "border-box",
                                transition: "border 0.2s ease-in-out, box-shadow 0.2s ease-in-out, background-color 0.2s ease-in-out",
                                padding: "6px",
                              }}
                            >
                              {/* Cart Count Badge */}
                              {cartCount > 0 && (
                                <div
                                  style={{
                                    position: "absolute",
                                    right: "-8px",
                                    top: "-8px",
                                    height: "22px",
                                    width: "22px",
                                    backgroundColor: primaryColor || "#2B6CB0",
                                    borderRadius: "50%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "white",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    border: "none",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                                    zIndex: 10,
                                  }}
                                >
                                  {formattedCount}
                                </div>
                              )}

                              <img
                                alt="Logo"
                                style={{
                                  maxWidth: "90%",
                                  maxHeight: "90%",
                                  width: "auto",
                                  height: "auto",
                                  // borderRadius: "6px",
                                  objectFit: "contain",
                                }}
                                src={ele?.store_display_logo || ele?.store_logo || defaultimg}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = defaultimg;
                                }}
                              />
                            </div>
                          );
                        })}
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    padding: "0 18px",
                    margin: "20px 0 15px 0",
                    gap: "12px",
                    boxSizing: "border-box",
                  }}
                >
                  {/* Search Input Box */}
                  <Paper
                    elevation={0}
                    style={{
                      display: "flex",
                      flex: 1,
                      alignItems: "center",
                      padding: "0 12px",
                      borderRadius: "8px",
                      backgroundColor: "white",
                      border: "1px solid #E0E0E0",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                      height: "48px",
                      boxSizing: "border-box",
                    }}
                  >
                    <SearchIcon style={{ color: primaryColor || "#3f51b5", marginRight: "8px", fontSize: "22px" }} />
                    <InputBase
                      sx={{
                        ml: 1,
                        flex: 1,
                        "& input::placeholder": {
                          fontWeight: "500 !important",
                          color: "#64748b !important",
                          opacity: 1
                        }
                      }}
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#333",
                        width: "100%",
                      }}
                      placeholder="Search Items"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    {searchQuery && (
                      <IconButton
                        onClick={() => setSearchQuery("")}
                        style={{ padding: "4px", color: "#666" }}
                      >
                        <CloseIcon style={{ fontSize: "20px" }} />
                      </IconButton>
                    )}
                  </Paper>

                  {/* Filter Button */}
                  <button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      border: "1px solid #E0E0E0",
                      backgroundColor: "white",
                      color: "#1a1a1a",
                      fontWeight: "500",
                      fontSize: "14px",
                      cursor: "pointer",
                      height: "48px",
                      boxSizing: "border-box",
                      gap: "6px",
                      whiteSpace: "nowrap",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                    }}
                    onClick={() => setOpen(true)}
                  >
                    <TuneIcon style={{ fontSize: "18px", color: primaryColor || "#3f51b5" }} />
                    <span style={{ fontFamily: "Satoshi, Inter, Roboto, sans-serif" }}>Filter</span>
                  </button>
                </div>
              </div>
            </div>
          )}
          {isReload ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "300px",
                width: "100%",
              }}
            >
              <CircularProgress
                style={{
                  color: "#2196F3",
                  marginBottom: "16px",
                }}
              />
              <Typography
                variant="h6"
                style={{
                  color: "#666",
                  fontWeight: "500",
                }}
              >
                Loading Menu...
              </Typography>
            </div>
          ) : (
            <>
              {isDesktop ? (
                <>
                  <style>{`
                  .custom-scrollbar::-webkit-scrollbar { width: 4px; }
                  .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                  .custom-scrollbar::-webkit-scrollbar-thumb { background: ${primaryColor || '#eb5c24'}40; border-radius: 4px; }
                  .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: ${primaryColor || '#eb5c24'}60; }
                `}</style>
                  <Grid container style={{ minHeight: "70vh", backgroundColor: "transparent", padding: "14px 0" }} spacing={0}>
                    {/* Left Sidebar */}
                    <Grid item xs={4} md={3} style={{ borderRight: "1px solid #E0E0E0" }}>
                      <div ref={sidebarContainerRef} className="custom-scrollbar" style={{ overflowY: "auto", height: "calc(100vh - 160px)" }}>
                        {/* Search Bar */}
                        <Paper
                          elevation={0}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "4px 12px",
                            borderRadius: "8px",
                            backgroundColor: "#f5f5f5",
                            border: "none",
                            height: "45px",
                            margin: "0 20px 24px 20px"
                          }}
                        >
                          <SearchIcon style={{ color: "#333333", marginRight: "8px", fontSize: "25px" }} />
                          <InputBase
                            sx={{ ml: 1, flex: 1, fontSize: "19px", color: "#333333", "& input::placeholder": { color: "#333333", opacity: 1, fontWeight: 500 } }}
                            placeholder="Search dishes, categories..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                          {searchQuery && (
                            <IconButton size="small" onClick={() => setSearchQuery("")} style={{ padding: 4 }}>
                              <CloseIcon style={{ color: "#333333" }} />
                            </IconButton>
                          )}
                        </Paper>
                        {/* Categories List */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', padding: '0 20px' }}>
                          <Typography style={{ fontWeight: 600, color: primaryColor || BUTTON_COLOR, fontSize: '21px' }}>Categories</Typography>
                          <Typography style={{ fontSize: '16px', color: '#666' }}>{allitem?.length || 0} Items</Typography>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          {/* Tag Virtual Categories (e.g. Recommended) — shown at top */}
                          {(() => {
                            const tokens = (searchQuery || "").trim().split(/\s+/).filter(Boolean);
                            const tokenRegexes = tokens.map((tok) => {
                              const base = tok.replace(/(?:s|es)$/i, "");
                              const escBase = base.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                              const escTok = tok.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                              return new RegExp(`\\b(?:${escTok}|${escBase}(?:s|es)?)`, "i");
                            });
                            const matchesTokens = (txt) => Boolean(tokens.length && txt && tokenRegexes.every((rgx) => rgx.test(String(txt))));

                            const filteredTags = (tagCategories || []).filter(tag => {
                              if (!tokens.length) return true;
                              const matchesName = matchesTokens(tag.category_name);
                              const rawItems = searchQuery ? (itemList || []) : (activeCatalog?.items || []);
                              const tagName = String(tag.category_name).trim().toLowerCase();
                              const hasMatchingItems = rawItems.some(i => Array.isArray(i.tag) && i.tag.map(t => String(t).trim().toLowerCase()).includes(tagName));
                              return matchesName || hasMatchingItems;
                            });

                            const filteredCats = (allCategoryList || []).filter(cat => {
                              if (!tokens.length) return true;
                              const matchesName = matchesTokens(cat.category_name);
                              const sourceList = searchQuery ? itemList : allitem;
                              const hasMatchingItems = (sourceList || []).some(i => String(i.category_id) === String(cat.category_id));
                              return matchesName || hasMatchingItems;
                            });

                            if (searchQuery && filteredTags.length === 0 && filteredCats.length === 0) {
                              return (
                                <div style={{ padding: "30px 20px", textAlign: "center", color: "#666", fontSize: "16px", fontWeight: 500 }}>
                                  Category not found
                                </div>
                              );
                            }

                            return (
                              <>
                                {/* Tag Virtual Categories */}
                                {filteredTags.map(tag => {
                                  const isActive = String(selectedCategory) === String(tag.category_id);
                                  const tagName = tag.category_name;
                                  const rawItems = searchQuery ? (itemList || []) : (activeCatalog?.items || []);
                                  const itemCount = rawItems.filter(i => Array.isArray(i.tag) && i.tag.map(t => t.trim()).includes(tagName)).length;
                                  if (itemCount === 0) return null;

                                  const tagCategoryItems = (allitem || []).filter(item => {
                                    const itemTags = Array.isArray(item.tags)
                                      ? item.tags
                                      : (item.tags ? String(item.tags).split(',').map(t => t.trim()) : []);
                                    return itemTags.some(t => t.toLowerCase() === tagName.toLowerCase()) &&
                                      String(item.store_id) === String(activeStoreId) &&
                                      parseFloat(item?.item_variant?.[0]?.plu) >= 0;
                                  });
                                  const allOutOfStock = tagCategoryItems.length > 0 && tagCategoryItems.every(item => item.is_stock === false);

                                  return (
                                    <div
                                      key={tag.category_id}
                                      ref={(el) => (sidebarCategoryRefs.current[String(tag.category_id)] = el)}
                                      onClick={() => {
                                        setSelectedCategory(tag.category_id);
                                        setSelectedCategoryName(tag.category_name);
                                      }}
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '10px 20px 10px 16px',
                                        backgroundColor: isActive ? `${primaryColor || BUTTON_COLOR}15` : 'transparent',
                                        borderRadius: '0',
                                        cursor: 'pointer',
                                        borderLeft: isActive ? `4px solid ${primaryColor || BUTTON_COLOR}` : '4px solid transparent',
                                        transition: 'all 0.2s',
                                        gap: '8px',
                                      }}
                                    >
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0, flex: 1 }}>
                                        <div style={{ width: '32px', height: '32px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                          <span style={{ fontSize: '22px' }}>⭐</span>
                                        </div>
                                        <Typography
                                          noWrap
                                          style={{
                                            fontWeight: isActive ? 600 : 500,
                                            color: isActive ? (primaryColor || BUTTON_COLOR) : '#333',
                                            fontSize: '18px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {tagName}
                                        </Typography>
                                        {allOutOfStock && (
                                          <span style={{
                                            fontSize: "10px",
                                            backgroundColor: "white",
                                            color: "#d32f2f",
                                            border: "1px solid #d32f2f",
                                            padding: "2px 6px",
                                            borderRadius: "0.6rem",
                                            fontWeight: "700",
                                            textTransform: "uppercase",
                                            whiteSpace: "nowrap",
                                            flexShrink: 0,
                                          }}>
                                            Out of Stock
                                          </span>
                                        )}
                                      </div>
                                      <Typography style={{
                                        fontSize: '16px',
                                        backgroundColor: isActive ? (primaryColor || BUTTON_COLOR) : '#f0f0f0',
                                        color: isActive ? 'white' : '#666',
                                        padding: '2px 12px',
                                        borderRadius: '4px',
                                        fontWeight: 600,
                                        flexShrink: 0,
                                        minWidth: '24px',
                                        textAlign: 'center',
                                      }}>{itemCount}</Typography>
                                    </div>
                                  );
                                })}

                                {/* Normal Categories */}
                                {filteredCats.map(cat => {
                                  const isActive = String(selectedCategory) === String(cat.category_id);
                                  const sourceList = searchQuery ? itemList : allitem;
                                  const itemCount = sourceList?.filter(i => String(i.category_id) === String(cat.category_id))?.length || 0;
                                  if (itemCount === 0 && searchQuery) return null; // Only hide empty categories DURING a search

                                  const originalCategoryItems = (allitem || []).filter((item) =>
                                    String(item.category_id) === String(cat.category_id) &&
                                    String(item.store_id) === String(activeStoreId) &&
                                    parseFloat(item?.item_variant?.[0]?.plu) >= 0
                                  );
                                  const allOutOfStock = originalCategoryItems.length > 0 && originalCategoryItems.every(item => item.is_stock === false);

                                  return (
                                    <div
                                      key={cat.category_id}
                                      ref={(el) => (sidebarCategoryRefs.current[String(cat.category_id)] = el)}
                                      onClick={() => {
                                        setSelectedCategory(cat.category_id);
                                        setSelectedCategoryName(cat.category_name);
                                      }}
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '10px 20px 10px 16px',
                                        backgroundColor: isActive ? `${primaryColor || BUTTON_COLOR}15` : 'transparent',
                                        borderRadius: '0',
                                        cursor: 'pointer',
                                        borderLeft: isActive ? `4px solid ${primaryColor || BUTTON_COLOR}` : '4px solid transparent',
                                        transition: 'all 0.2s',
                                        gap: '8px',
                                      }}
                                    >
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0, flex: 1 }}>
                                        <div style={{ width: '32px', height: '32px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                          {(() => {
                                            if (!cat?.cat_img && !cat?.cat_icon) return null;
                                            const sid = String(cat?.store_id || activeStoreId || storeInfo?.store_id || '').trim();
                                            const rawImg = cat?.cat_img ? String(cat.cat_img).trim().replace(/^\/+/, '') : '';
                                            const baseUrl = (IMG_URL || '').replace(/\/+$/, '');
                                            const imgSrc = !rawImg
                                              ? cat.cat_icon
                                              : (rawImg.startsWith('http://') || rawImg.startsWith('https://'))
                                              ? rawImg
                                              : (sid && !rawImg.startsWith(`${sid}/`))
                                              ? `${baseUrl}/${sid}/${rawImg}`
                                              : `${baseUrl}/${rawImg}`;
                                              console.log("Category Image Source:", imgSrc); // Debugging line to check the image source
                                            return (
                                              <img
                                                src={imgSrc}
                                                alt=""
                                                style={{ height: '32px', width: '32px', objectFit: 'contain' }}
                                                onError={(e) => { e.target.style.visibility = 'hidden'; }}
                                              />
                                            );
                                          })()}
                                        </div>
                                        <Typography
                                          noWrap
                                          style={{
                                            fontWeight: isActive ? 600 : 500,
                                            color: isActive ? (primaryColor || BUTTON_COLOR) : '#333',
                                            fontSize: '18px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {cat.category_name}
                                        </Typography>
                                        {allOutOfStock && (
                                          <span style={{
                                            fontSize: "10px",
                                            backgroundColor: "white",
                                            color: "#d32f2f",
                                            border: "1px solid #d32f2f",
                                            padding: "2px 6px",
                                            borderRadius: "0.6rem",
                                            fontWeight: "700",
                                            textTransform: "uppercase",
                                            whiteSpace: "nowrap",
                                            flexShrink: 0,
                                          }}>
                                            Out of Stock
                                          </span>
                                        )}
                                      </div>
                                      <Typography style={{
                                        fontSize: '16px',
                                        backgroundColor: isActive ? (primaryColor || BUTTON_COLOR) : '#f0f0f0',
                                        color: isActive ? 'white' : '#666',
                                        padding: '2px 12px',
                                        borderRadius: '4px',
                                        fontWeight: 600,
                                        flexShrink: 0,
                                        minWidth: '24px',
                                        textAlign: 'center',
                                      }}>{itemCount}</Typography>
                                    </div>
                                  );
                                })}
                              </>
                            );
                          })()}
                        </div>
                      </div>
                    </Grid>

                    {/* Right Main Content */}
                    <Grid item xs={8} md={9} style={{ paddingLeft: "24px" }}>
                      <div ref={itemsContainerRef} className="custom-scrollbar" style={{ overflowY: "auto", height: "calc(100vh - 160px)", paddingRight: "12px" }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', paddingRight: '12px' }}>
                          <Typography variant="h5" style={{ fontWeight: 600, fontSize: '21px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {(() => {
                              if (String(selectedCategory).startsWith('tag__')) {
                                return <span style={{ fontSize: '36px', color: '#FFB300', lineHeight: 1 }}>⭐</span>;
                              }
                              const activeCatObj = allCategoryList?.find(c => String(c.category_id) === String(selectedCategory));
                              if (activeCatObj && (activeCatObj.cat_img || activeCatObj.cat_icon)) {
                                const sid = String(activeCatObj?.store_id || activeStoreId || storeInfo?.store_id || '').trim();
                                const rawImg = activeCatObj?.cat_img ? String(activeCatObj.cat_img).trim().replace(/^\/+/, '') : '';
                                const baseUrl = (IMG_URL || '').replace(/\/+$/, '');
                                const imgSrc = !rawImg
                                  ? activeCatObj.cat_icon
                                  : (rawImg.startsWith('http://') || rawImg.startsWith('https://'))
                                  ? rawImg
                                  : (sid && !rawImg.startsWith(`${sid}/`))
                                  ? `${baseUrl}/${sid}/${rawImg}`
                                  : `${baseUrl}/${rawImg}`;
                                return (
                                  <img
                                    src={imgSrc}
                                    alt=""
                                    style={{ height: '48px', width: '48px', objectFit: 'contain', borderRadius: '6px' }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                  />
                                );
                              }
                              return null;
                            })()}
                            {selectedCategoryName}
                            {(() => {
                              if (selectedCategory === "All_Item") return null;
                              let originalCategoryItems = [];
                              if (String(selectedCategory).startsWith('tag__')) {
                                const tagName = String(selectedCategory).replace('tag__', '');
                                originalCategoryItems = (allitem || []).filter(item => {
                                  const itemTags = Array.isArray(item.tags) ? item.tags : (item.tags ? String(item.tags).split(',').map(t => t.trim()) : []);
                                  return itemTags.some(t => t.toLowerCase() === tagName.toLowerCase()) &&
                                    String(item.store_id) === String(activeStoreId) &&
                                    parseFloat(item?.item_variant?.[0]?.plu) >= 0;
                                });
                              } else {
                                originalCategoryItems = (allitem || []).filter((item) =>
                                  String(item.category_id) === String(selectedCategory) &&
                                  String(item.store_id) === String(activeStoreId) &&
                                  parseFloat(item?.item_variant?.[0]?.plu) >= 0
                                );
                              }
                              const allOutOfStock = originalCategoryItems.length > 0 && originalCategoryItems.every(item => item.is_stock === false);
                              if (allOutOfStock) {
                                return (
                                  <span style={{
                                    fontSize: "12px",
                                    backgroundColor: "white",
                                    color: "#d32f2f",
                                    border: "1px solid #d32f2f",
                                    padding: "4px 10px",
                                    borderRadius: "0.6rem",
                                    marginLeft: "10px",
                                    fontWeight: "700",
                                    textTransform: "uppercase",
                                  }}>
                                    Out of Stock
                                  </span>
                                );
                              }
                              return null;
                            })()}
                          </Typography>
                          <Typography style={{ color: '#666', fontSize: '16px' }}>
                            {(() => {
                              if (searchQuery) return itemList?.length;
                              if (selectedCategory === "All_Item") return allitem?.length;
                              if (String(selectedCategory).startsWith('tag__')) {
                                const tagName = String(selectedCategory).replace('tag__', '');
                                return allitem?.filter(i => Array.isArray(i.tag) && i.tag.includes(tagName))?.length;
                              }
                              return allitem?.filter(i => String(i.category_id) === String(selectedCategory))?.length;
                            })()} items
                          </Typography>
                        </div>

                        <Items
                          {...props}
                          isDesktop={true}
                          selectedCategory={searchQuery ? "All_Item" : selectedCategory}
                          tagCategories={tagCategories}
                          {...{
                            allCategoryList,
                            itemList,
                            allitem,
                            selectedCategoryName,
                            itemVerriantList,
                            addonList,
                            currency,
                            storeInfo,
                            storeInfoConfig,
                            selectedfilter,
                          }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <Grid
                  item
                  justifyContent="center"
                  style={{
                    minHeight: "70vh",
                    backgroundColor: "transparent",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <div
                    style={{ display: "flex", padding: "0px", margin: "18px" }}
                  >

                    {hasDietaryItems && (checkedItems.includes("Veg") || checkedItems.includes("Non-veg")) && (
                      <div
                        style={{
                          display: "flex",
                          overflowX: "auto",
                          paddingBottom: "8px",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        {checkedItems.includes("Veg") && (
                          <button
                            style={{
                              ...buttonBaseStyle,
                              color: "#333333",
                              backgroundColor: "#fff",
                              border: `1px solid ${primaryColor || BUTTON_COLOR}`,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "8px",
                              position: "relative",
                              whiteSpace: "nowrap",
                              flexShrink: 0,
                            }}
                            onClick={() => handleCheckboxChange("Veg")}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <img
                                src={VegIcon}
                                style={{ width: "18px", height: "18px" }}
                              />
                              <span style={{ fontWeight: "600", marginLeft: "6px" }}>
                                Veg
                              </span>
                            </div>
                            <span
                              style={{
                                marginLeft: "6px",
                                fontSize: "14px",
                                color: "#333333",
                                fontWeight: "bold",
                              }}
                            >
                              ×
                            </span>
                          </button>
                        )}

                        {checkedItems.includes("Non-veg") && (
                          <button
                            style={{
                              ...buttonBaseStyle,
                              color: "#333333",
                              backgroundColor: "#fff",
                              border: `1px solid ${primaryColor || BUTTON_COLOR}`,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "8px",
                              position: "relative",
                              whiteSpace: "nowrap",
                              flexShrink: 0,
                            }}
                            onClick={() => {
                              dispatch(clearCart());
                              dispatch(clear_customer());
                              dispatch(clear_order_details());
                              dispatch(clear_order_type());
                              dispatch(clear_last_order());
                              dispatch(clear_order_request());
                              navigate("/", { state: { skipAutoRedirect: true } });
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <img
                                src={NonVegIcon}
                                style={{ width: "18px", height: "18px" }}
                              />
                              <span style={{ fontWeight: "600", marginLeft: "6px" }}>
                                Non-veg
                              </span>
                            </div>
                            <span
                              style={{
                                marginLeft: "6px",
                                fontSize: "14px",
                                color: "#333333",
                                fontWeight: "bold",
                              }}
                            >
                              ×
                            </span>
                          </button>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Enhanced Sidebar */}
                  <Drawer
                    anchor="right"
                    open={openSidebar}
                    onClose={handleSidebarClose}
                    PaperProps={{
                      style: {
                        backgroundColor: "#FAFAFA",
                        borderRadius: "0px",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 320,
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        boxSizing: "border-box",
                      }}
                      role="presentation"
                      onClick={handleSidebarClose}
                      onKeyDown={handleSidebarClose}
                    >
                      <div>
                        {menuStore ? (
                          ""
                        ) : (
                          <>
                            {/* User Profile Section */}
                            <div
                              style={{
                                padding: "16px 24px",
                                background: primaryColor || BUTTON_COLOR,
                                color: "white",
                                borderRadius: "0px",
                                marginBottom: "16px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setOpenUserInfo(true);
                                if (typeof setSkipSignin === "function") setSkipSignin(true);
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center" }}>
                                <div
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    background: primaryColor || BUTTON_COLOR,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    // marginRight: "16px",
                                    // border: "2px solid white",
                                  }}
                                >
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 38 38"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M10.5556 8.44444C10.5556 6.20484 11.4452 4.05696 13.0289 2.47332C14.6125 0.88968 16.7604 0 19 0C21.2396 0 23.3875 0.88968 24.9711 2.47332C26.5548 4.05696 27.4444 6.20484 27.4444 8.44444C27.4444 10.6841 26.5548 12.8319 24.9711 14.4156C23.3875 15.9992 21.2396 16.8889 19 16.8889C16.7604 16.8889 14.6125 15.9992 13.0289 14.4156C11.4452 12.8319 10.5556 10.6841 10.5556 8.44444ZM10.5556 21.1111C7.75605 21.1111 5.0712 22.2232 3.09165 24.2028C1.1121 26.1823 0 28.8672 0 31.6667C0 33.3464 0.66726 34.9573 1.85499 36.145C3.04272 37.3327 4.65363 38 6.33333 38H31.6667C33.3464 38 34.9573 37.3327 36.145 36.145C37.3327 34.9573 38 33.3464 38 31.6667C38 28.8672 36.8879 26.1823 34.9084 24.2028C32.9288 22.2232 30.244 21.1111 27.4444 21.1111H10.5556Z"
                                      fill="white"
                                    />
                                  </svg>
                                </div>
                                <div>
                                  <Typography
                                    variant="h6"
                                    style={{
                                      fontWeight: "700",
                                      marginBottom: "4px",
                                    }}
                                  >
                                    {customer !== null && customer?.cust_first_name
                                      ? customer.cust_first_name
                                      : "Guest User"}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    style={{
                                      opacity: 0.9,
                                      fontSize: "14px",
                                    }}
                                  >
                                    Tap to manage account
                                  </Typography>
                                </div>
                              </div>
                            </div>
                            {/* Navigation Menu */}
                            {!getFSRStatus() && (
                              <div style={{ padding: "0 16px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "12px 16px",
                                    borderRadius: "16px",
                                    backgroundColor: "white",
                                    marginBottom: "12px",
                                    cursor: "pointer",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                                    transition: "all 0.3s ease",
                                  }}
                                  onClick={() => {
                                    if (props.clear_customer) {
                                      props.clear_customer();
                                    }
                                    navigate("/", { state: { skipAutoRedirect: true } });
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: "3px",
                                    }}
                                  >
                                    <HomeIcon
                                      style={{ color: primaryColor, fontSize: "40px" }}
                                    />
                                  </div>
                                  <Typography
                                    style={{
                                      fontWeight: "600",
                                      color: "#333",
                                      fontSize: "24px",
                                    }}
                                  >
                                    <span style={{ fontSize: "18px" }}>Home</span>
                                  </Typography>
                                </div>
                              </div>
                            )}{" "}
                            {/* Show Recent Order only if customer details exist and not menuStore */}
                            {!menuStore && customer !== null && customer?.cust_first_name && (
                              <div style={{ padding: "0 16px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "16px",
                                    borderRadius: "16px",
                                    backgroundColor: "white",
                                    marginBottom: "12px",
                                    cursor: "pointer",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                                    transition: "all 0.3s ease",
                                  }}
                                  onClick={() => navigate("/customer")}
                                >
                                  <div
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "8px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: "3px",
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 19 23"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M14.3983 0.942773L16.3114 5.73696C16.3907 5.93602 16.4365 6.1164 16.469 6.32954L18.9838 21.211C19.1016 21.9089 18.5611 22.5445 17.8528 22.5406L12.5191 22.5135C12.4412 22.5142 12.3742 22.467 12.3464 22.3909C12.3182 22.3148 12.3368 22.2323 12.395 22.1781C12.682 21.9103 12.8639 21.52 12.8678 21.0866L13 6.3919L14.0496 0.978708C14.0658 0.894507 14.13 0.83391 14.2115 0.825807C14.2929 0.817352 14.3669 0.863504 14.3983 0.942773ZM7.73477 3.20458H10.4104C10.7013 3.20458 10.94 2.9548 10.94 2.6497V2.12758C10.94 1.82284 10.7013 1.5727 10.4104 1.5727H7.73477H5.05877C4.7679 1.5727 4.52921 1.82284 4.52921 2.12758V2.6497C4.52921 2.9548 4.7679 3.20458 5.05877 3.20458H7.73477ZM7.73477 0H12.835C13.0705 0 13.3096 0.207156 13.2627 0.447782L12.0996 6.3919L11.967 21.0866C11.96 21.8909 11.3391 22.5476 10.5719 22.5476H1.40122C0.633322 22.5476 -0.0732258 21.8871 0.00610221 21.0866L1.43894 6.60751L3.41967 0.447782C3.44859 0.203281 3.61182 0 3.84699 0H7.73477Z"
                                        fill={primaryColor || "#3159A6"}
                                      />
                                    </svg>
                                  </div>
                                  <Typography
                                    style={{
                                      fontWeight: "600",
                                      color: "#333",
                                      fontSize: "16px",
                                    }}
                                  >
                                    <span style={{ fontSize: "18px" }}>Recent Order</span>

                                  </Typography>
                                </div>
                              </div>
                            )}
                            {/* Legal & Support Links */}
                            <div
                              style={{
                                marginTop: "24px",
                                padding: "16px",
                                borderTop: "1px solid #E0E0E0",
                              }}
                            >
                              <Typography
                                variant="caption"
                                style={{
                                  color: "#666",
                                  fontWeight: "600",
                                  marginBottom: "16px",
                                  display: "block",
                                }}
                              >
                                <span
                                  style={{ fontSize: "12px", }}>LEGAL & SUPPORT</span>
                              </Typography>

                              {[
                                { text: "Privacy Policy", path: "/privacy-policy" },
                                { text: "Refund Policy", path: "/refund-policy" },
                                { text: "Shipping Policy", path: "/shipping-policy" },
                                { text: "Terms & Conditions", path: "/terms-condition" },
                                { text: "Contact Us", path: "/contactus" },
                              ].map((link, index, array) => (
                                <div
                                  key={index}
                                  style={{
                                    padding: "6px 0",
                                    borderBottom:
                                      index < array.length - 1 ? "2px solid #F0F0F0" : "none",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => navigate(link.path)}
                                >
                                  <Typography
                                    style={{
                                      color: "#333333",
                                      fontSize: "21px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    <span style={{ fontSize: "15px" }}>{link.text}</span>
                                  </Typography>
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                      </div>

                      {/* Powered By Logo & FSSAI */}
                      {!menuStore && (
                        <div
                          style={{
                            marginTop: "60px",
                            padding: "16px 16px 24px 16px",
                            textAlign: "center",
                            backgroundColor: "#FAFAFA",
                            borderTop: "1px solid #F0F0F0",
                          }}
                        >
                          {storeFssai && (
                            <div style={{ marginBottom: "16px" }}>
                              <img
                                alt="FSSAI Logo"
                                style={{ width: "70px", height: "auto", display: "inline-block" }}
                                src={fssaiimage}
                              />
                              <Typography style={{ fontSize: "13px", color: "#333", fontWeight: "500", marginTop: "4px" }}>
                                License No. - {storeFssai}
                              </Typography>
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "1.1rem",
                                color: "#A0AEC0",
                                fontFamily: "Satoshi",
                                fontWeight: "500",
                              }}
                            >
                              Powered By
                            </span>
                            <img
                              alt="Logo"
                              style={{ width: "80px", height: "auto" }}
                              src={CyntraLogo}
                            />
                          </div>
                        </div>
                      )}
                    </Box>
                  </Drawer>

                  <MenuCategories
                    {...props}
                    {...{
                      allitem,
                      labelList,
                      allCategoryList,
                      selectedCategory,
                      filterItems,
                      setOpen,
                    }}
                  />

                  <FilterPopup
                    {...props}
                    {...{
                      dietaryArray,
                      isReload,
                      checkedItems,
                      setCheckedItems,
                      itemList,
                      setItemList,
                      setDietaryFilter,
                      setSelectedfilter,
                      selectedfilter,
                      open,
                      setOpen,
                      storeInfo,
                    }}
                  />

                  <Items
                    {...props}
                    tagCategories={[]}
                    {...{
                      allCategoryList,
                      itemList,
                      allitem,
                      selectedCategoryName,
                      itemVerriantList,
                      addonList,
                      currency,
                      storeInfo,
                      storeInfoConfig,
                      selectedfilter,
                    }}
                  />
                </Grid>
              )}
            </>
          )}

          {/* View Cart Button (Web View: New Image 2 design, Mobile View: Original Image 1 design) */}
          <div
            className="ViewBtn"
            style={{
              display: addedItems.length ? "flex" : "none",
            }}
          >
            {isDesktop ? (
              /* Web / Desktop View - Image 2 Design */
              <Button
                variant="contained"
                disableElevation
                onClick={handleCheckout}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: primaryColor || "#ea4819",
                  color: "#ffffff",
                  borderRadius: "50px",
                  padding: "6px 16px 6px 6px",
                  height: "54px",
                  maxWidth: "380px",
                  textTransform: "none",
                  boxShadow: "none",
                  transition: "all 0.2s ease-in-out",
                  cursor: "pointer",
                }}
              >
                {/* Left Group: White circle with Cart icon + View Cart & Details */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <div
                    style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "50%",
                      backgroundColor: "#ffffff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      boxShadow: "none",
                    }}
                  >
                    <ShoppingCartIcon
                      style={{
                        color: primaryColor || "#ea4819",
                        fontSize: "22px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      textAlign: "left",
                    }}
                  >
                    <Typography
                      style={{
                        color: "#ffffff",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "1.2",
                        letterSpacing: "0.2px",
                      }}
                    >
                      View Cart
                    </Typography>
                    <Typography
                      style={{
                        color: "#ffffff",
                        fontWeight: "500",
                        fontSize: "13px",
                        lineHeight: "1.2",
                        opacity: 0.95,
                        marginTop: "1px",
                      }}
                    >
                      {addedItems.length} {addedItems.length > 1 ? "Items" : "Item"}
                      {" | "}
                      <span style={{ fontWeight: "600" }}>
                        {currency}
                        {(() => {
                          const totalVal = props?.cartProps?.total || 0;
                          return totalVal % 1 === 0
                            ? totalVal.toFixed(0)
                            : totalVal.toFixed(2);
                        })()}
                      </span>
                    </Typography>
                  </div>
                </div>

                {/* Right Group: Chevron Right Icon */}
                <ChevronRightIcon
                  style={{
                    color: "#ffffff",
                    fontSize: "28px",
                    marginLeft: "8px",
                    flexShrink: 0,
                  }}
                />
              </Button>
            ) : (
              /* Mobile View - Responsive Design using CSS custom properties */
              <Button
                variant="contained"
                onClick={handleCheckout}
                style={{
                  fontSize: "var(--checkout-text-font-size, 1.3rem)",
                  borderRadius: "8px",
                  height: "50px",
                  minWidth: "100%",
                  color: "white" || TEXT_COLOR,
                  backgroundColor: primaryColor || BUTTON_COLOR,
                }}
              >
                <Grid
                  xs={4}
                  sm={4}
                  md={4}
                  lg={4}
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "var(--checkout-cart-circle-size, 30px)",
                      height: "var(--checkout-cart-circle-size, 30px)",
                      borderRadius: "50%",
                      backgroundColor: "white",
                    }}
                  >
                    <img
                      alt="cart"
                      src={cart}
                      style={{
                        display: "block",
                        width: "var(--checkout-cart-icon-size, 17px)",
                        height: "var(--checkout-cart-icon-size, 17px)",
                      }}
                    />
                  </div>
                  <Typography
                    style={{
                      paddingLeft: "var(--checkout-pill-padding, 0.5rem)",
                      fontWeight: "600",
                    }}
                  >
                    <span style={{ fontSize: "var(--checkout-text-font-size, 1.3rem)" }}>
                      {addedItems.length}{" "}
                      {addedItems.length > 1 ? "Items" : "Item"}
                    </span>
                  </Typography>
                </Grid>
                <Grid
                  xs={8}
                  sm={8}
                  md={8}
                  lg={8}
                  style={{
                    paddingLeft: "var(--checkout-pill-padding, 0.5rem)",
                    background: "white",
                    borderRadius: "8px",
                    display: "flex",
                    fontSize: "var(--checkout-text-font-size, 1.3rem)",
                    marginRight: "var(--checkout-pill-margin-right, -1rem)",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    style={{
                      color: "black",
                      padding: "var(--checkout-pill-padding, 0.5rem)",
                      fontWeight: "700",
                    }}
                  >
                    <span
                      style={{
                        fontSize: currency === "OMR " ? "0.5rem" : undefined,
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "600",
                          fontSize: "var(--checkout-currency-font-size, 16px)",
                        }}
                      >
                        {currency}{" "}
                      </span>
                    </span>
                    {Number(props?.cartProps?.total || 0).toFixed(2)}
                  </Typography>
                  <Typography
                    style={{
                      color: "black",
                      fontWeight: "600",
                    }}
                  >
                    <span style={{ fontSize: "var(--checkout-text-font-size, 1.3rem)" }}>
                      Checkout
                    </span>
                  </Typography>

                  <Typography
                    style={{
                      color: "black",
                      padding: "var(--checkout-pill-padding, 0.5rem)",
                      fontWeight: "700",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      alt="cart"
                      src={icon}
                      style={{
                        width: "var(--checkout-arrow-icon-size, 17px)",
                        height: "var(--checkout-arrow-icon-size, 17px)",
                      }}
                    />
                  </Typography>
                </Grid>
              </Button>
            )}
          </div>
        </Grid>
      </div>

      <style jsx>{`
        .ViewBtn {
          --checkout-text-font-size: 1.3rem;
          --checkout-currency-font-size: 16px;
          --checkout-pill-padding: 0.5rem;
          --checkout-cart-circle-size: 30px;
          --checkout-cart-icon-size: 17px;
          --checkout-arrow-icon-size: 17px;
          --checkout-pill-margin-right: -1rem;
        }

        @media only screen and (max-width: 375px) {
          .ViewBtn {
            --checkout-text-font-size: 1.1rem;
            --checkout-currency-font-size: 14px;
            --checkout-pill-padding: 0.35rem;
            --checkout-cart-circle-size: 26px;
            --checkout-cart-icon-size: 15px;
            --checkout-arrow-icon-size: 15px;
            --checkout-pill-margin-right: -0.75rem;
          }
        }

        @media only screen and (max-width: 340px) {
          .ViewBtn {
            --checkout-text-font-size: 0.95rem;
            --checkout-currency-font-size: 13px;
            --checkout-pill-padding: 0.25rem;
            --checkout-cart-circle-size: 22px;
            --checkout-cart-icon-size: 13px;
            --checkout-arrow-icon-size: 13px;
            --checkout-pill-margin-right: -0.5rem;
          }
        }

        @keyframes move {
          0% {
            transform: translateX(-20px);
          }
          100% {
            transform: translateX(0px);
          }
        }

        .ViewBtn:hover button {
          transform: translateY(-2px);
          box-shadow: none;
        }

        /* Scrollbar Styling */
        ::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }

        ::-webkit-scrollbar-thumb {
          border-radius: 10px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
        }
      `}</style>
      <Dialog
        open={confirmPopup}
        onClose={() => setConfirmPopup(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "20px",
            padding: "20px",
            backgroundColor: "#fff",
          },
        }}
      >
        <DialogTitle
          style={{
            padding: "0px",
            marginBottom: "10px",
          }}
        >
          <Typography
            style={{
              fontFamily: "Plus Jakarta Sans",
              fontSize: "30px",
              color: primaryColor || "#000",
              fontWeight: "700",
              textAlign: "center",
            }}
          >
            <span style={{ fontSize: "20px" }}>Switch Outlet?</span>
          </Typography>
        </DialogTitle>

        <DialogContent style={{ padding: "0px", marginBottom: "20px" }}>
          <Typography
            style={{
              fontFamily: "Satoshi",
              fontSize: "14px",
              color: "#333333",
              textAlign: "left",
              fontWeight: "500",
            }}
          >

            Switching to {pendingStore?.store_name} will clear your cart.
            Do you wish to proceed?
          </Typography>
        </DialogContent>

        <DialogActions style={{ padding: "0px", justifyContent: "flex-start", gap: "10px" }}>
          <Button
            onClick={() => setConfirmPopup(false)}
            variant="contained"
            disableElevation

            style={{
              flex: "1",
              borderRadius: "8px",
              fontSize: "14px",
              color: "white" || "#fff",
              backgroundColor: primaryColor || "#000",
              textTransform: "none",
              fontWeight: "700",
              padding: "8px",
              boxShadow: "none",
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={confirmStoreTabSwitch}
            variant="contained"
            disableElevation
            style={{
              flex: "1",
              borderRadius: "8px",
              fontSize: "14px",
              border: `1px solid ${primaryColor || "#000"}`,
              color: primaryColor || "#000",
              background: secondaryColor || "#fff",
              textTransform: "none",
              fontWeight: "600",
              padding: "8px",
              boxShadow: "none",
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openOutOfStock}
        onClose={() => setOpenOutOfStock(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "20px",
            padding: "20px",
            backgroundColor: "#fff",
          },
        }}
      >
        <DialogTitle
          style={{
            padding: "0px",
            marginBottom: "10px",
          }}
        >
          <Typography
            style={{
              fontFamily: "Plus Jakarta Sans",
              color: primaryColor || "#000",
              fontWeight: "700",
              textAlign: "center",
            }}
          >
            <span style={{ fontSize: "20px" }}>Out of Stock</span>
          </Typography>
        </DialogTitle>

        <DialogContent style={{ padding: "0px", marginBottom: "20px" }}>
          <Typography
            style={{
              fontFamily: "Satoshi",
              fontSize: "14px",
              color: "#333333",
              textAlign: "left",
              fontWeight: "500",
            }}
          >
            Some items or addons in your cart are currently out of stock. We cannot process your order.
          </Typography>
          <div style={{ maxHeight: "200px", overflowY: "auto", marginTop: "15px", border: "1px solid #EDF2F7", borderRadius: "8px" }}>
            {outOfStockItems?.map((item, idx) => (
              <div
                key={idx}
                style={{
                  padding: "10px 14px",
                  borderBottom: idx === outOfStockItems.length - 1 ? "none" : "1px solid #EDF2F7",
                  fontSize: "14px",
                  color: "#2D3748",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontFamily: "Satoshi"
                }}
              >
                <span style={{ fontWeight: "600" }}>{item.item_name}</span>
                <span
                  style={{
                    fontSize: "12px",
                    color: "#718096",
                    backgroundColor: "#EDF2F7",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    textTransform: "capitalize"
                  }}
                >
                  {item.type}
                </span>
              </div>
            ))}
          </div>
        </DialogContent>

        <DialogActions style={{ padding: "0px", justifyContent: "center" }}>
          <Button
            onClick={() => {
              remove_out_of_stock_from_cart(outOfStockItems, addedItems, props.removeItem, props.clearCart);
              setOpenOutOfStock(false);
            }}
            variant="contained"
            disableElevation
            style={{
              flex: "1",
              borderRadius: "8px",
              fontSize: "14px",
              color: "white",
              backgroundColor: primaryColor || "#000",
              textTransform: "none",
              fontWeight: "700",
              padding: "8px",
              boxShadow: "none",
            }}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cartProps: state.cartReducer,
    reducer: state.customerReducer,
    filterReducer: state.filterReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    set_customer: (obj) => {
      dispatch(set_customer(obj));
    },
    clear_customer: () => {
      dispatch(clear_customer());
    },
    set_last_order: (obj) => {
      dispatch(set_last_order(obj));
    },
    set_filters: (obj) => {
      dispatch(set_filters(obj));
    },
    set_order_type: (obj) => {
      dispatch(set_order_type(obj));
    },
    clearCart: () => {
      dispatch(clearCart());
    },
    removeItem: (item) => {
      dispatch(removeItem(item));
    },
    order_place: (obj) => {
      dispatch(order_place(obj));
    },
    clear_last_order: () => {
      dispatch(clear_last_order());
    },
    update_item_list: (items) => {
      dispatch({ type: "ITEM_LIST", item_list: items });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Menu);
